module.exports = __webpack_public_path__ + "img/house-rent.7c47eaae.png";